

import { BidiModule } from '@angular/cdk/bidi';
import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MwcOutletModule } from 'mwc/core/outlet';
import { MwcIconModule } from 'mwc/icon';

import { MwcMessageContainerComponent } from './message-container.component';
import { MwcMessageComponent } from './message.component';
import { MwcMessageServiceModule } from './message.service.module';

@NgModule({
  imports: [BidiModule, CommonModule, OverlayModule, MwcIconModule, MwcOutletModule, MwcMessageServiceModule],
  declarations: [MwcMessageContainerComponent, MwcMessageComponent]
})
export class MwcMessageModule {}
